import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../../../../api/quarkusApi';

// Procedimentos de um protocolo estético — a URL base é passada pelo componente
// (ex.: /patients/{id}/aesthetic-protocols/{protocolId}/procedures).
export function useAestheticProcedures(baseUrl) {
  const navigate = useNavigate();

  const [data, setData] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchProcedures = useCallback(() => {
    if (!baseUrl) {
      setData(null);
      return;
    }
    setLoading(true);
    quarkusApi
      .get(baseUrl, { headers: { Authorization: sessionStorage.getItem('token') } })
      .then((returnFromApi) => setData(returnFromApi.data))
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [baseUrl, navigate]);

  useEffect(() => {
    fetchProcedures();
  }, [fetchProcedures]);

  return { data, isLoading, error, refetch: fetchProcedures };
}
